module.exports = __webpack_public_path__ + "img/device_point6-2_m.ad96d55b.png";